export class RBTEstado {
    estado:string;
    causaTerminacion:string;
    cantidad: number=0;
}

